import { Button, Dialog, DialogContent, DialogContentText } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { DocumentTemplateVersionSTO } from "src/models/document-templates/document-template-version/document-template-version-sto";
import { DocumentTemplateVersionApiService } from "src/services/document-templates/document-template-version-api.service";
import { toastifyResponse } from "src/utils/toastify-response/toastify-response";
import { DocumentTemplateVersionDTO } from "../../../models/document-templates";
import DialogActions from "../../DialogActions/DialogActions";
import DialogTitle from "../../DialogTitle/DialogTitle";

interface RemoveDocumentTemplateVersionProps {
  item: DocumentTemplateVersionDTO;
  disabled?: boolean;
  handleNotifyParent: () => void;
}

interface State {
  isDialogOpen: boolean;
  isLoading: boolean;
}

const RemoveDocumentTemplateVersion = ({
  item,
  disabled = false,
  handleNotifyParent,
}: RemoveDocumentTemplateVersionProps) => {
  const { t } = useTranslation();

  const [state, setState] = useState<State>({
    isDialogOpen: false,
    isLoading: false,
  });

  const handleDeleteVersion = async () => {
    setState((state) => ({
      ...state,
      isLoading: true,
    }));
    try {
      const deletedVersion = {
        ...item,
        isDeleted: true,
      } as DocumentTemplateVersionSTO;

      const response = await new DocumentTemplateVersionApiService().saveItems([deletedVersion]);

      if (!response.error) {
        setState((state) => ({
          ...state,
          isDialogOpen: false,
        }));
        if (handleNotifyParent) {
          handleNotifyParent();
        }
      } else {
        toastifyResponse(response, "failed");
      }
    } catch (error) {
      console.error("Error deleting version:", error);
      toast(error as string);
    } finally {
      setState((state) => ({
        ...state,
        isLoading: false,
      }));
    }
  };

  // const handleDelete = async () => {
  //   setState((prevState) => ({ ...prevState, isLoading: true }));
  //   try {
  //     await handleDeleteItem();
  //     setState((prevState) => ({ ...prevState, isDialogOpen: false }));
  //   } finally {
  //     setState((prevState) => ({ ...prevState, isLoading: false }));
  //   }
  // };

  return (
    <>
      <Button
        title={`${t(`components.confirmation_remove_item_dialog.title`)}`}
        variant="text"
        color="error"
        disabled={disabled}
        onClick={() => setState((prevState) => ({ ...prevState, isDialogOpen: true }))}
      >
        {t("common_words.delete")}
      </Button>

      <Dialog
        open={state.isDialogOpen}
        onClose={() => setState((prevState) => ({ ...prevState, isDialogOpen: false }))}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          title={t(`components.confirmation_remove_item_dialog.title`)}
          handleClose={() => setState((prevState) => ({ ...prevState, isDialogOpen: false }))}
        />
        <DialogContent>
          <DialogContentText>
            {t(`components.confirmation_remove_item_dialog.message`)}
            {item.version && ` (Version: ${item.version})`}
          </DialogContentText>
        </DialogContent>
        <DialogActions handleCancel={() => setState((prevState) => ({ ...prevState, isDialogOpen: false }))}>
          <Button
            onClick={handleDeleteVersion}
            color="error"
            variant="contained"
            disabled={state.isLoading}
          >
            {t("common_words.delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveDocumentTemplateVersion;
